// OrderAnswer.js
import React from 'react';
import { Typography } from '@material-tailwind/react';

export const OrderAnswer = ({ data }) => (
    <div className="flex flex-col gap-3 p-4">
        <div className="flex items-center gap-4 mb-4 flex-col">
            <Typography variant="h6" className="text-gray-900">
                Zending gevonden!
            </Typography>
            <img
                src="https://www.dhl.com/content/dam/dhl/global/core/images/logos/dhl-logo.svg"
                alt="DHL Logo"
                className="h-4 w-auto"
            />
        </div>

        <div className="flex flex-col gap-2">
            <div>
                <Typography variant="small" className="font-semibold">
                    Track en Trace verstuurd naar emailadres:
                </Typography>
                <Typography variant="small">
                    {data.email}
                </Typography>
            </div>

            <div>
                <Typography variant="small" className="font-semibold">
                    Afleveradres:
                </Typography>
                <Typography variant="small">
                    {data.adres}<br />
                    {data.postcode}<br />
                    {data.place}
                </Typography>
            </div>

            <div>
                <Typography variant="small" className="font-semibold">
                    Zending ID:
                </Typography>
                <Typography variant="small">
                    {data.sendingId}
                </Typography>
            </div>

            <a
                href={data.trackingurl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 bg-[#FFCC00] text-black px-4 py-2 rounded hover:bg-[#e6b800] transition-colors text-center"
            >
                📦 Volg je pakket
            </a>
        </div>
    </div>
);